import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { tapScale } from '../motion';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'sm' | 'md' | 'lg';

export interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'children'> {
  variant?: Variant;
  size?: Size;
  icon?: React.ReactNode;
  loading?: boolean;
  block?: boolean;
  iconOnly?: boolean;
  /** 押すと消費するクレジット */
  cost?: number;
  children?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'secondary',
  size = 'md',
  icon,
  loading,
  block,
  iconOnly,
  cost,
  className,
  children,
  disabled,
  ...rest
}) => {
  const cls = [
    'v2-btn',
    `v2-btn--${variant}`,
    size !== 'md' && `v2-btn--${size}`,
    block && 'v2-btn--block',
    iconOnly && 'v2-btn--icon',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <motion.button
      type="button"
      className={cls}
      whileTap={disabled || loading ? undefined : tapScale}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <span className="v2-spinner" aria-hidden /> : icon}
      {children && <span className="v2-btn-label">{children}</span>}
      {cost !== undefined && !loading && <span className="v2-btn-cost">{cost.toLocaleString()} cr</span>}
    </motion.button>
  );
};

/** リンクとして働くボタン（ダウンロード・別タブ）。 */
export const LinkButton: React.FC<
  { href: string; variant?: Variant; icon?: React.ReactNode; download?: boolean; newTab?: boolean; children: React.ReactNode }
> = ({ href, variant = 'secondary', icon, download, newTab, children }) => (
  <motion.a
    className={`v2-btn v2-btn--${variant}`}
    href={href}
    download={download || undefined}
    target={newTab ? '_blank' : undefined}
    rel={newTab ? 'noreferrer' : undefined}
    whileTap={tapScale}
  >
    {icon}
    <span className="v2-btn-label">{children}</span>
  </motion.a>
);
